"use strict";

angular.module('ccasignupModule').component("ccaReports", {
    templateUrl: '/Scripts/app/ccaSignUp/Details/cca-reports.template.html',
    controller: [
    function () {

    }
]});